import { AXIOS } from "../config/axios.config";

class LanguageService {
  async fetchLanguages() {
    return await AXIOS.get("/lang/findAll");
  }
}
export default new LanguageService();
